!function(w, d, s, u) {
if (w.oaiq) return;
var q = function() {
    q.q.push(arguments);
};
q.q = [];
w.oaiq = q;
var j = d.createElement(s);
j.async = 1;
j.src = u;
var f = d.getElementsByTagName(s)[0];
f.parentNode.insertBefore(j, f);
}(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

oaiq("init", {
pixelId: "LmXpot5sdrJ6M1t262n5tV",
debug: true
});

oaiq("measure", "registration_completed", {
type: "customer_action",
amount: 0,
currency: "USD"
});